module.exports = __webpack_public_path__ + "img/Icon_Tooltip_Triangle.94b1a49b.svg";